import styled from 'styled-components/macro';
import { AmendmentStatus, ContractInfo, amendment, biData } from '../../slice/types';
import { DisplayFieldHorizontal } from '../DisplayFieldHorizontal';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';
import { Divider, Grid } from '@mui/material';
import { commonStyle } from '../../../../../styles/theme/themes';
import React, { useState } from 'react';
import { SectionStatusBlock } from './SectionStatusBlock';
import moment from 'moment';
export function BIUpdateCard(props: { data: amendment; index: any; lastBIData: amendment | null }) {
  const { data, index, lastBIData } = props;
  const { t } = useTranslation();
  const biData = data.data as biData;
  const creationDate = biData?.contractInfo?.submitDate;
  const submittedBy = biData?.contractInfo?.submittedBy;
  const relatedSections = data.relatedSections ? data.relatedSections : {};
  const statusReasons = data.statusReasons ? data.statusReasons : {};
  const status = data.status;
  const dataDateStr = biData?.contractInfo?.actualMoveOutDate ?? "";
  const lastBIDateStr = (lastBIData?.data as biData)?.contractInfo?.actualMoveOutDate ?? "";
  const actualMoveOutDateRelated = biData?.contractInfo?.actualMoveOutDate && dataDateStr !== lastBIDateStr;
  const [selecting, setSelecting] = useState(false);

  // const updateDisplayCBD = () => {
  //   setSelecting(!selecting);
  // };


  return (
    <Wrapper>
      {status &&
      <div
        className={`card ${(status as string) === (AmendmentStatus.COMPLETE as string) ? 'complete' : 'pending'} ${selecting && 'highlight'}`}>
        <Grid container className='header'>
          <Grid item md={4}>
            {t(translations.contractDetail.billingInstruction)}
            { actualMoveOutDateRelated && <br/> }
            { actualMoveOutDateRelated && t(translations.contractDetail.amendment.actualMoveOutDateRelated) }
            {
              biData?.contractInfo?.isVoided && <div>
                <strong>{t(translations.contractDetail.amendment.contractVoided)}</strong>
              </div>
            }
          </Grid>
          <Grid item md={4} className='center'>
            Version. {index}
          </Grid>
          <Grid item md={4} className='right'>
            {status}
          </Grid>
        </Grid>
        <Divider />
        <div className='content'>
          <div className='row'>
            <DisplayFieldHorizontal
              label={translations.contractDetail.amendment.submittionDate}
              value={moment(creationDate).format('YYYY-MM-DD HH:mm:ss')}
            />
          </div>
          <div className='row'>
            <DisplayFieldHorizontal
              label={translations.contractDetail.contractInformation.submittedBy}
              value={submittedBy}
            />
          </div>
          <div className='status'>
            {Object.keys(relatedSections).map((item, index) => (
              <SectionStatusBlock sectionName={item} sectionStatus={relatedSections[item]} statusReason={statusReasons[item]} key={index}/>
            ))}
          </div>
        </div>
      </div>
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .card {
    padding: 5px;
    margin: 5px 0;
    border-radius: 5px;
    box-shadow: ${commonStyle.boxShadow};
  }

  .complete {
    background-color: ${p => p.theme.complete};
  }

  .pending {
    background-color: ${p => p.theme.pending};
  }

  .highlight {
    border: 2px solid ${p => p.theme.primary};
    margin: 3px -2px -2px -2px;
  }

  .header {
    .center {
      text-align: center;
    }

    .right {
      text-align: right;
    }
  }

  .content {
    background-color: white;
    padding-bottom: 5px;

    .row {
      padding-top: 5px;
    }

    .status {
      display: flex;
    }
  }
`;
